import React, { useEffect, useState } from "react"
import Style from "@/components/VisualSearch/v1/LoadingData/loadingdata.module.scss"
import Heading from "@/components/core/Heading/Heading"
import useViewport from "@/hooks/useViewport"
import QRCode from "@/components/VisualSearch/v1/QRCode"
import { getProductByImage } from "@/services/ct.service"
import { data } from "@/components/VisualSearch/v1/LoadingData/constant"
import { addDataLayerVisualSearch } from "@/components/VisualSearch/analytics"
import {
  getDetailSku,
  getValidCategory,
} from "@/components/VisualSearch/v1/utils"

const LoadingData = props => {
  const {
    image = [],
    category = "",
    setSection,
    setOpenCam,
    setProductResult,
    setLoading,
    eventType,
  } = props
  const [progress, setProgress] = useState(data[0])
  const [productData, setProductData] = useState(null)
  const device = useViewport()

  useEffect(() => {
    let timeId1
    let timeId2
    let timeId3
    if (image && category) {
      timeId1 = setTimeout(() => setProgress(data[1]), 1000)
      timeId2 = setTimeout(() => setProgress(data[2]), 2500)
      timeId3 = setTimeout(() => setProgress(data[3]), 4000)
      setOpenCam(false)
      const categoryVal = getValidCategory(category)
      getSkuNumberByImage(image, categoryVal)
    }
    return () => {
      clearTimeout(timeId1)
      clearTimeout(timeId2)
      clearTimeout(timeId3)
    }
  }, [image, category])

  useEffect(() => {
    document.body.classList.remove("overflow-hidden")
  }, [productData])

  const getSkuNumberByImage = async (image, category = "faucets") => {
    const { file } = image
    try {
      setLoading(false)
      if (file && category) {
        const formdata = new FormData()
        formdata.append("category", category)
        formdata.append("file", file)
        const response = await getProductByImage(formdata)

        if (response?.data?.result) {
          setProductData(response?.data?.result)
          addDataLayerVisualSearch({
            eventKey: eventType,
            eventStatus: "success",
            product: response.data.result,
            category: category,
            linkUrl: response.data.result.pdpUrl,
          })
          const slug = response?.data?.result?.slug
          const skuId = response?.data?.result?.sku
          const resp = await getDetailSku(slug, skuId)
          setSection("result")
          const mergedResponse = {
            ...response?.data?.result,
            allswatch: [resp],
          }
          setLoading(true)
          setProductResult(mergedResponse)
          document.body.classList.remove("overflow-hidden")
        } else {
          setProductData(null)
          addDataLayerVisualSearch({
            eventKey: eventType,
            eventStatus: "failure",
            category: category,
            eventMsg: "sorry something went wrong",
          })
          setSection("error")
          setLoading(false)
        }
      }
    } catch (err) {
      console.error("Error in getSkuNumberByImage", err)
      setSection("error")
    }
  }

  if (!category) return null

  return (
    <div className={Style.LoadingImage}>
      <div className="image-loading-container visualContentwarpper d-flex justify-content-center align-items-center">
        <div className="upload-image d-flex justify-content-center align-items-center flex-column">
          <div className="icon-upload">
            <img src={progress?.imageUrl} alt={progress?.text} />
          </div>
          <Heading fontSize={34} level={4} className="loading-text">
            {progress?.text}
          </Heading>
        </div>
      </div>
      {!device?.isSmallTabView ? <QRCode /> : null}
    </div>
  )
}

export default LoadingData
